module.exports = __webpack_public_path__ + "static/media/Random_walk.28b18f06.avif";